import React from 'react';
import RouteSummaryItem from './RouteSummaryItem';
import ErrorMessage from './ErrorMessage';
import MESSAGES from '../../../../../appMessages';
import { withStyles } from '@material-ui/core';
import { getSelectedRouteMessage } from '../utils';

const styles = (theme) => ({
  routeSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  selectedRoutesMessage: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    color: theme.gridTextColor
  },
  errorColor: {
    color: theme.ErrorMessageColor
  }
});

const RoutesSummary = ({ data, classes }) => {
  const selectedRoutesMessage = getSelectedRouteMessage(data);

  return (
    <div className={classes.routeSummaryContainer}>
      <div
        className={`${classes.selectedRoutesMessage} ${
          data.totalLockedRoutes ? classes.errorColor : ''
        }`}>
        {selectedRoutesMessage}
      </div>
      <RouteSummaryItem
        details={data.routesSummary?.selectedRoutes}
        label="Selected Routes"
        isPrimary
      />
      {data.error && <ErrorMessage error={data.error} />}
      <RouteSummaryItem
        details={data.routesSummary?.unselectedRoutes}
        label="Other Routes"
        info={MESSAGES.ROUTE_OPTIMIZATION.OTHER_ROUTES_INFO_MESSAGE}
      />
    </div>
  );
};

export default withStyles(styles)(RoutesSummary);
